import React, { useEffect, useState } from "react";
import axios from "axios";
import { baseUrl } from "../../config/baseUrl";
import { ToastMessgae } from "../utils/toast";
import { toast, Bounce } from "react-toastify";
import { useNavigate } from "react-router-dom";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";

export default function UserAdd({
  modelType,
  showModel,
  setShowModel,
  adminDataApi,
  companyNameData,
}) {
  const navigate = useNavigate();
  const loginUser = JSON.parse(localStorage.getItem("user"));

  const [formval, setFormval] = useState({
    first_name: "",
    last_name: "",
    password: "",
    mobile: "",
    email: "",
    username: "",
    company: "",
    depo: [],
    country_code: "",
    profile_image: null,
    user_type: "",
  });

  const [depoData, setDepoData] = useState([]);

  const ChangeHandler = (e, countryData) => {
    if (typeof e === "string") {
      return setFormval((curr) => ({
        ...curr,
        country_code: countryData.dialCode,
        mobile: e,
      }));
    }

    if (e.target.name === "depo") {
      return setFormval((curr) => {
        const id = parseInt(e.target.value);
        const exists = curr.depo.includes(id);
        return {
          ...curr,
          depo: exists ? curr.depo.filter((d) => d !== id) : [...curr.depo, id],
        };
      });
    }

    if (e.target.name === "profile_image") {
      return setFormval((curr) => ({
        ...curr,
        profile_image: e.target.files[0],
      }));
    }

    setFormval((curr) => ({
      ...curr,
      [e.target.name]: e.target.value,
    }));
  };

  const depoApi = async () => {
    try {
      const response = await axios(`${baseUrl}/module/admin/depo-viewset`, {
        method: "GET",
        headers: {
          Authorization: "Token " + localStorage.getItem("token"),
        },
      });
      setDepoData(response?.data?.data);
    } catch (err) {
      ToastMessgae({ message: "Failed to load depo data" });
    }
  };

  useEffect(() => {
    depoApi();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const payload = { ...formval, mobile: formval.mobile.slice(2) };

    // Basic validations
    if (
      !payload.first_name ||
      !payload.last_name ||
      !payload.password ||
      !payload.username ||
      !payload.email
    ) {
      ToastMessgae({ message: "All fields are required" });
      return;
    }

    if (modelType === "ADMIN_MANAGER" && !payload.user_type) {
      ToastMessgae({ message: "Role is required" });
      return;
    }

    if (!payload.company) {
      payload.company = loginUser.company;
    }

    // Prepare FormData
    const formData = new FormData();
    Object.entries(payload).forEach(([key, value]) => {
      if (key === "depo") {
        value.forEach((id) => formData.append("depo", [id]));
      } else if (value !== undefined && value !== null) {
        formData.append(key, value);
      }
    });

    try {
      const response = await axios(`${baseUrl}/module/admin/user-viewset`, {
        method: "POST",
        headers: {
          Authorization: "Token " + localStorage.getItem("token"),
          "Content-Type": "multipart/form-data",
        },
        data: formData,
      });

      if (response?.data?.code === 400) {
        toast.error(response?.data?.error_message || response?.data?.message, {
          position: "top-right",
          autoClose: 2000,
          theme: "light",
          transition: Bounce,
        });
        return;
      }

      toast.success(response?.data?.message, {
        position: "top-right",
        autoClose: 2000,
        theme: "light",
        transition: Bounce,
      });

      setShowModel(false);
      setShowModel((prev) => prev + 1);
      adminDataApi();

      setFormval({
        first_name: "",
        last_name: "",
        password: "",
        mobile: "",
        email: "",
        username: "",
        company: "",
        depo: [],
        country_code: "",
        profile_image: null,
        user_type: "",
      });

      document?.getElementById("unique")?.click();
      navigate("/user-List");
    } catch (error) {
      console.error("Error:", error?.response?.data);
      ToastMessgae({
        message: error?.response?.data?.message || "Request failed",
      });
    }
  };

  return (
    <div
      className="modal fade custom-modal users-modal"
      id="add-user"
      tabIndex={-1}
    >
      <div className="modal-dialog modal-fullscreen">
        <div className="modal-content">
          <div className="modal-header justify-content-center">
            <h5 className="modal-title">
              {modelType === "ADMIN_MANAGER" ? "Add New User" : "Add Admin"}
            </h5>
            <button
              type="button"
              className="modal-close"
              data-bs-dismiss="modal"
            >
              <i className="fa fa-times" />
            </button>
          </div>
          <div className="modal-body">
            <div className="table modal-table">
              <table className="table">
                <thead>
                  <tr>
                    <th>First Name *</th>
                    <th>Last Name *</th>
                    <th>Email *</th>
                    <th>Username *</th>
                    <th>Mobile</th>
                    <th>Password *</th>
                    {modelType === "SUPER_ADMIN" ? (
                      <th>Company</th>
                    ) : (
                      <>
                        <th>Role *</th>
                        <th>Depot</th>
                      </>
                    )}
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="First Name"
                        name="first_name"
                        value={formval.first_name}
                        onChange={ChangeHandler}
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Last Name"
                        name="last_name"
                        value={formval.last_name}
                        onChange={ChangeHandler}
                      />
                    </td>
                    <td>
                      <input
                        type="email"
                        className="form-control"
                        placeholder="Email"
                        name="email"
                        value={formval.email}
                        onChange={ChangeHandler}
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Username"
                        name="username"
                        value={formval.username}
                        onChange={ChangeHandler}
                      />
                    </td>
                    <td>
                      <PhoneInput
                        name="mobile"
                        value={formval.mobile}
                        country={"in"}
                        onChange={ChangeHandler}
                      />
                    </td>
                    <td>
                      <input
                        type="password"
                        className="form-control"
                        placeholder="Password"
                        name="password"
                        value={formval.password}
                        onChange={ChangeHandler}
                      />
                    </td>

                    {modelType === "SUPER_ADMIN" ? (
                      <td>
                        <select
                          name="company"
                          className="form-select"
                          value={formval.company}
                          onChange={ChangeHandler}
                        >
                          <option value="">Select Company</option>
                          {companyNameData?.map((c) => (
                            <option key={c.id} value={c.id}>
                              {c.company_name}
                            </option>
                          ))}
                        </select>
                      </td>
                    ) : (
                      <>
                        <td>
                          <select
                            name="user_type"
                            className="form-select"
                            value={formval.user_type}
                            onChange={ChangeHandler}
                          >
                            <option value="">Select Role</option>
                            <option value="CLEANER">Cleaner</option>
                            {loginUser?.user_type !== "CLEANING_MANAGER" &&
                              loginUser?.user_type !== "CLIENT" && (
                                <option value="CLEANING_MANAGER">
                                  Cleaning Manager
                                </option>
                              )}
                            {loginUser?.user_type !== "CLIENT" && (
                              <option value="CLIENT">Client</option>
                            )}
                          </select>
                        </td>
                        <td className="tablemenu-bar">
                          <div className="dropdown">
                            <button
                              className="dropdown-toggle"
                              type="button"
                              data-bs-toggle="dropdown"
                            >
                              Select Depot
                            </button>
                            <ul className="dropdown-menu">
                              {depoData.map((d) => (
                                <li key={d.id} className="dropdown-item">
                                  <div className="form-check">
                                    <input
                                      type="checkbox"
                                      className="form-check-input"
                                      name="depo"
                                      value={d.id}
                                      checked={formval.depo.includes(d.id)}
                                      onChange={ChangeHandler}
                                    />
                                    <label>{d.depo_name}</label>
                                  </div>
                                </li>
                              ))}
                            </ul>
                          </div>
                        </td>
                      </>
                    )}
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-outline-secondary rounded-5"
              data-bs-dismiss="modal"
              id="unique"
            >
              Cancel
            </button>
            <button className="thm-btn" onClick={handleSubmit}>
              Submit
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
